/*
  Mary Tassel – zurückhaltendes Einblenden beim Scrollen.
  Betrifft Sektionen unterhalb des ersten Bildschirms; der Hero bleibt sofort sichtbar.
*/
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const STAGGER = 80;
  const MAX_STAGGER = 4;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const init = () => {
    const sections = document.querySelectorAll('#MainContent > .shopify-section');
    sections.forEach((section, index) => {
      if (index === 0) return;
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight) return;

      const wrapper = section.querySelector('.section-content-wrapper, .section-resource-list, .section');
      const children = wrapper ? Array.from(wrapper.children).slice(0, 8) : [section];
      children.forEach((child, i) => {
        child.classList.add('mt-reveal');
        child.style.setProperty('--mt-delay', `${Math.min(i, MAX_STAGGER) * STAGGER}ms`);
        observer.observe(child);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/*
  Mary Tassel – gewählte Farbe neben dem Optionsnamen anzeigen („Farbe Band  olivgrün“).
  Horizon rendert die Variantenauswahl bei jeder Auswahl neu, daher per MutationObserver.
*/
(() => {
  const update = () => {
    document.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
      const checked = fieldset.querySelector("input[data-option-name^='Farbe']:checked");
      const legend = fieldset.querySelector('legend');
      if (!checked || !legend) return;
      let span = legend.querySelector('.mt-option-value');
      if (!span) {
        span = document.createElement('span');
        span.className = 'mt-option-value';
        legend.append(span);
      }
      if (span.textContent !== checked.value) span.textContent = checked.value;
    });
  };

  const start = () => {
    update();
    new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', update);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/*
  Mary Tassel – Barrierefreiheit: Horizons Gruppen-Link ist ein leeres <a> über der Karte.
  Er bekommt den sichtbaren Titel der Karte als Namen (z. B. „Ohrringe Gold“).
*/
(() => {
  const label = () => {
    document.querySelectorAll('a.group-block__link:not([aria-label])').forEach((link) => {
      const group = link.closest('.group-block');
      const heading = group && group.querySelector('h1, h2, h3, h4, h5, h6, p, .h4, .h6');
      const text = (heading ? heading.textContent : group ? group.textContent : '').trim().replace(/\s+/g, ' ');
      if (text) link.setAttribute('aria-label', text.slice(0, 80));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', label, { once: true });
  } else {
    label();
  }
})();
